import { useEffect, useState } from 'react'
import useSWR from 'swr'
import { fetchWithToken } from './http'

interface PlanCount {
  periodId: string
  count: number
}

export function usePlanCounts(
  token: string,
  rootOrganizationId: string | null,
  rootPeriodId: string | null,
  shouldFetch: boolean = true
) {
  const [isLoading, setIsLoading] = useState(false)
  const shouldFetchData =
    token != null && token.trim() !== '' && rootOrganizationId != null && rootPeriodId != null && shouldFetch

  const { data, error, mutate } = useSWR(
    shouldFetchData ? [`compensation/plans/counts/${rootOrganizationId}/${rootPeriodId}`, token] : null,
    ([url, token]) => fetchWithToken(url, token, null),
    {
      suspense: false,
      revalidateIfStale: false,
      revalidateOnFocus: false,
    }
  )

  useEffect(() => {
    if (shouldFetchData) {
      setIsLoading(true)
      mutate().finally(() => {
        setIsLoading(false)
      })
    }
  }, [shouldFetchData, mutate])

  const handleRefetch = () => {
    setIsLoading(true)
    mutate().finally(() => {
      setIsLoading(false)
    })
  }

  // Convert array response to map of periodId -> count
  const planCountsMap: Record<string, number> = {}
  if (data && Array.isArray(data)) {
    data.forEach((item: PlanCount) => {
      if (item.periodId) {
        planCountsMap[item.periodId] = item.count
      }
    })
  }

  return {
    planCounts: planCountsMap,
    isLoadingPlanCounts: isLoading,
    isError: error,
    handleRefetch,
  }
}
